import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-search-word"]
const _hoisted_2 = { class: "inline-flex overflow-hidden" }
const _hoisted_3 = { class: "truncate" }
const _hoisted_4 = { class: "flex flex-none gap-2" }


import { useFavoritesStore } from '@/stores/favorites';
import { useLocationStore } from '@/stores/location';
import { TranslateKey, useInject } from '@/composables/use-inject';
import AppIcon from '@/components/Base/AppIcon.vue';
import AppTooltip from '@/components/Base/AppTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemFavoritesItem',
  props: {
  index: {
    type: Number,
    required: true,
  },
  searchWord: {
    type: String,
    required: true,
  },
},
  emits: {
  effect: null,
},
  setup(__props, { emit }) {

const props = __props;





const translate = useInject(TranslateKey);
const locationStore = useLocationStore();
const favoritesStore = useFavoritesStore();

const getItemLabel = (): string => {
  return `${props.index}. ${props.searchWord}`;
};

const handleSearchButtonClick = (): void => {
  locationStore.activeSearchWord = props.searchWord;
  emit('effect');
};

const handleRemoveButtonClick = (): void => {
  favoritesStore.removeFavorite(props.searchWord);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-search-word": props.searchWord,
    class: "bg-lighten-xs flex items-center justify-between gap-2 rounded py-1.5 px-2 text-sm"
  }, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(getItemLabel()), 1)
    ]),
    _createElementVNode("span", _hoisted_4, [
      _createVNode(AppTooltip, { placement: "bottom" }, {
        popper: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(translate)('itemFavorites.searchButton')), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "brightness-50 hocus:brightness-100",
            onClick: handleSearchButtonClick
          }, [
            _createVNode(AppIcon, {
              src: require('@/assets/images/list-filter/search.png'),
              class: "h-[24px] drop-shadow-md"
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }),
      _createVNode(AppTooltip, { placement: "bottom" }, {
        popper: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(translate)('itemFavorites.removeButton')), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "brightness-50 hocus:brightness-100",
            onClick: handleRemoveButtonClick
          }, [
            _createVNode(AppIcon, {
              src: require('@/assets/images/list-filter/remove.png'),
              class: "h-[24px] drop-shadow-md"
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      })
    ])
  ], 8, _hoisted_1))
}
}

})